import { Injectable, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { Filter } from './filter-form/filter.class';
import { QueryParams } from './grid/grid-params';

@Injectable()
export class FilterFormBuilder {

  public filters: { [field: string]: Filter } = {};
  private filterForm: FormGroup;
  private queryParamsSubscription: Subscription = null;

  constructor(
    private formBuilder: FormBuilder,
    private queryParams: QueryParams
  ) { }

  ngOnDestroy() {
    if (this.queryParamsSubscription !== null) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  public createFilters(filters: Filter[]) {
    this.buildForm(filters);
    this.updateValues();

    // TODO unsubscribe
    this.queryParamsSubscription = this.queryParams.onChange.subscribe(
      () => this.updateValues()
    );
  }

  public updateValues() {
    for (let filterName in this.filters) {
      if (!this.filters.hasOwnProperty(filterName)) {
        continue;
      }

      this.filters[filterName].updateValue();
    }
  }

  public getFilterForm(): FormGroup {
    return this.filterForm;
  }

  private buildForm(filters: Filter[]) {
    let form: { [key: string]: any } = {};

    for (let key in filters) {
      if (!filters.hasOwnProperty(key)) {
        continue;
      }

      let filter: Filter = filters[key];
      filter.setQueryParams(this.queryParams);
      form[filter.getFilterName()] = filter.getFormElement();
      this.filters[filter.getFilterName()] = filter;
    }

    this.filterForm = this.formBuilder.group(form);
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/filter-form-builder.ts